import React from 'react';

import SmartLink from 'dpl/components/SmartLink';
import {
  HOUSE_TRAINING_YOUR_PUPPY,
  PUPPY_TRAINING_PROGRAM,
  SOCIALIZATION_PROGRAM,
  TEACHING_PUPPY_MANNERS
} from 'dpl/shared/constants/urls';
import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';

import dogOnBed from 'dpl/assets/pages/puppy_college/dog_on_bed.png';
import house from 'dpl/assets/pages/puppy_college/house.png';
import yellowPuppy from 'dpl/assets/pages/puppy_college/yellow_puppy.png';

export default function PuppyCollegeEducationTiles() {
  const courses = [
    {
      title: 'House Training',
      url: HOUSE_TRAINING_YOUR_PUPPY,
      image: house
    },
    {
      title: 'Manners',
      url: TEACHING_PUPPY_MANNERS,
      image: dogOnBed
    },
    {
      title: 'Socialization',
      url: SOCIALIZATION_PROGRAM,
      image: yellowPuppy
    }
  ];

  return (
    <section className="EducationTilesSection pt0 pt6-md pb20 relative">
      <div className="container relative">
        <div className="mb6 mb14-lg row">
          <div className="col-lg-9 center">
            <h2 className="md:font-40 xs:font-28 tc-l">Popular courses</h2>
          </div>
        </div>
        <ul className="mb10 EducationTilesSectionList">
          {courses.map((course, idx) => {
            return (
              <li key={idx}>
                <SmartLink to={course.url}>
                  <div className="d-lg-block b--gray-300 bg-gray-100 ba br4 pb10 tc pt6">
                    <SmartImage
                      Tag="div"
                      width="300px"
                      height="300px"
                      className="w-100 h-100 cover bg-center"
                      src={course.image}
                      loadingClass="bg-light-gray"
                    />
                    <p className="flex items-center justify-center font-24 fw-medium font-serif">
                      {course.title}
                      <span className="bg-white br-100 ml2 secondary">
                        <Icon name="fetch-chevron-right" />
                      </span>
                    </p>
                  </div>
                </SmartLink>
              </li>
            );
          })}
        </ul>
        <div className="tc">
          <SmartLink
            to={PUPPY_TRAINING_PROGRAM}
            className="font-16 fw-medium pv3 ba b--shadow br1 dib-ns db ph0-ns ph12"
          >
            Explore the Puppy Training Program
          </SmartLink>
        </div>
      </div>
    </section>
  );
}
